import type {PublicMethodUtils} from '@wix/document-services-types'
import type {Wix2xPublicAPI} from '@wix/document-services-public-types'
import {wix2x, responsiveLayout, breakpoints} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<Wix2xPublicAPI> {
    return {
        methods: {
            responsive: {
                migration: {
                    /**
                     * @param {boolean} isResponsive - sets the isResponsive flag of the site
                     */
                    setResponsive: publicMethodUtils.defineDataManipulationAction(wix2x.setResponsive),
                    responsiveLayout: {
                        update: publicMethodUtils.defineDataManipulationAction(responsiveLayout.update)
                    },
                    breakpoints: {
                        update: publicMethodUtils.defineDataManipulationAction(breakpoints.update)
                    }
                }
            }
        }
    }
}
